import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import groupimg from "../../../assets/Images/svg/003-hexagonal.svg";
import deviceimg from "../../../assets/Images/svg/004-server.svg";
import { IOption } from "../../../models/ICommon";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import FormikFormFileInput from "../../../shared-components/FormikFormHandlers/FormikFormFileInput";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";
import FormikFormTextArea from "../../../shared-components/FormikFormHandlers/FormikFormTextArea";
import Label from "../../../shared-components/Label/Label";
import { formatMessage } from "../../../translations/format-message";

import moment from "moment";
import {
  DATE_TIME_FORMAT,
  DATE_TIME_FORMAT_WITHOUT_SECONDS,
  downloadDeviceICCIDDummyCSVHandler,
} from "../../../constants/common-constants";
import { scheduleDurationDayOptions } from "../../../constants/options.constant";
import { IAddReleaseScheduler } from "../../../models/Form/IAddUpdateReleaseScheduler";
import FormikDateFieldMUI from "../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import FormikFormInputMultipleSelect from "../../../shared-components/FormikFormHandlers/FormikFormMultipleOptionSelector";
import { addSchudlerValidationSchema, updateSchudlerValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import CustomTooltip from "../../../shared-components/Tooltip/tooltip";
import "./fota-form.css";
import FormikDateTimeFieldMUI from "../../../shared-components/FormikFormHandlers/FormikDateTimeFieldMUI";

export interface IPropsTenantAdmin {
  initialValues: IAddReleaseScheduler;
  submitHandler: (data: any) => void;
  onModalClosed: () => void;
  dataLoading: boolean;
  actionLoading: boolean;
  groupOptions: IOption[];
  configOptions: IOption[];
  title: string;
  schedulerId: number;
}

const ScheduleFirmwareUpdateForm = (props: IPropsTenantAdmin) => {
  const [targetData, setTargetData] = useState("");
  const [noOfRecords, setNoOfRecords] = useState<number>(0);
  const [fileType, setFileType] = useState<string>("");
  const [hostVersionFileContent, setHostVersionFileContent] = useState<any>("");

  let totalEnteriesInCSV: number = 0;

  const handleFileReadHostVersionFileContent = (event: any) => {
    const content = event.target.result;
    setHostVersionFileContent(content);
  };

  const getHeaderArray = (csvRecordsArr: any): string[] => {
    let headerArray = [];
    let headers = csvRecordsArr[0].split(",");
    for (let i = 0; i < headers.length; i++) {
      headerArray.push(headers[i]);
    }
    return headerArray;
  };

  const headerInvalidError = (headersRow: any) => {
    var isInvalid: boolean = false;
    if (!headersRow[0]?.trim()?.includes("ICCID")) {
      isInvalid = true;
      return isInvalid;
    }
    return isInvalid;
  };

  const handleICCIDFileUpload = (event: any) => {
    var files = event?.target?.result;
    setTargetData(files.toString());
  };

  const getFileName = (file: string) => {
    let val;
    if (file) {
      val = file.split(".");
      setFileType(val[1].toLowerCase());
    } else setFileType("");
  };

  const startFileDecode = () => {
    if (targetData) {
      let csvData: string = targetData;
      let csvRecordsArray = csvData?.split(/\r\n|\n/);
      let headersRow = getHeaderArray(csvRecordsArray);
      if (csvRecordsArray.length > 0) {
        totalEnteriesInCSV = csvRecordsArray.length - 2;
      }
      let invalid = headerInvalidError(headersRow);
      if (invalid) {
        toast.error(formatMessage("invalid_headers"));
      } else {
        if (csvRecordsArray[1] != "") {
          let csv = CSVDataConditions(headersRow, csvRecordsArray);
          if (csv && csv?.length > 0) {
            return csv;
          }
        } else {
          toast.error(formatMessage("empty_csv"));
          return [];
        }
      }
    } else {
      toast.error(formatMessage("invalid_csv_format"));
    }
  };

  const getNoOfRecordsFromFile = (values: IAddReleaseScheduler) => {
    let totalEnteries: number = 0;
    if (values.ICCIDsFile == "") {
      setTargetData("");
    } else {
      if (targetData && fileType === "csv") {
        let csvData: string = targetData;
        let csvRecordsArray = csvData?.split(/\r\n|\n/);
        if (csvRecordsArray.length > 0) {
          totalEnteries = csvRecordsArray.length - 2;
        }
      }
      setNoOfRecords(totalEnteries);
    }
    return totalEnteries;
  };

  const CSVDataConditions = (headersRow: any, csvRecordsArray: any) => {
    let dataManipulated = getDataRecordsArrayFromCSVFile(
      csvRecordsArray,
      headersRow.length
    );
    return dataManipulated;
  };

  const getDataRecordsArrayFromCSVFile = (
    csvRecordsArray: any,
    headerLength: number
  ) => {
    var ImportDataArr = [];
    var totalColumns = 1;
    csvRecordsArray.splice(csvRecordsArray.length - 1, 1);
    for (let i = 1; i < csvRecordsArray?.length; i++) {
      let data = csvRecordsArray[i]?.split(",");
      let splits = data[2]?.split(".");
      if (data[2] != "") {
        splits = splits
          ?.map((str: any) => str.replace(/\\/g, "").replace(/"/g, ""))
          .filter(Boolean);
      }
      if (data.length > totalColumns) {
        data.splice(totalColumns);
      }
      if (data.length == totalColumns) {
        ImportDataArr.push(data[0]?.trim());
      }
    }
    return ImportDataArr;
  };

  // const FormObserver: React.FC = () => {
  //     const { values, setFieldValue } = useFormikContext<IFotaTenantAdmin>();

  //     useEffect(() => {
  //       if (values.File && !values.IsCustomFileName) {
  //         let fileName = getFileNameAndExtensionFromPath(values.File)
  //         setFieldValue("FileName", fileName);
  //       }
  //     }, [values.File]);

  //     return null;
  //   }

  return (
    <Modal
      className="fancy-modal"
      show={true}
      size="lg"
      centered
      onHide={() => { }}
    >
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
        <button
          onClick={(e) => props.onModalClosed()}
          disabled={props.actionLoading}
          className="Crossicons"
          title={formatMessage("close")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={props.initialValues}
          validationSchema={props.schedulerId > 0 ? updateSchudlerValidationSchema : addSchudlerValidationSchema}
          enableReinitialize
          validateOnBlur={false}
          onSubmit={async (values: any) => {
            let tempValues: IAddReleaseScheduler = { ...values };
            let scheduleDate =
              new Date(values.ScheduleDate?.$d).toString() !==
                "Invalid Date"
                ? moment(values.ScheduleDate.$d).format(DATE_TIME_FORMAT_WITHOUT_SECONDS)
                : values.ScheduleDate;
            if (props.schedulerId === -1) {
              tempValues.ScheduleDate = tempValues.IsUpdateNow === "1" ?
                moment(new Date()).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : scheduleDate;
              let data: Array<string> | undefined = undefined;
              if (values.IsAppliedOnGroup !== "true") {
                data = values.ICCIDsFile ? startFileDecode() : [];
                tempValues.ICCIDs = data && data?.length > 0 ? data : [];
                tempValues.GroupIds = [];
              } else {
                tempValues.ICCIDs = [];
              }
            }
            else {
              tempValues.ScheduleDate = scheduleDate;
              if (values.WantToUpdateDevices === "true") {
                let data: Array<string> | undefined = undefined;
                if (values.IsAppliedOnGroup !== "true") {
                  data = values.ICCIDsFile ? startFileDecode() : [];
                  tempValues.ICCIDs = data && data?.length > 0 ? data : [];
                  tempValues.GroupIds = [];
                } else {
                  tempValues.ICCIDs = [];
                }
              }
              else {
                tempValues = { ...tempValues, IsAppliedOnGroup: false, GroupIds: [], ICCIDs: values.ICCIDs };
              }
            }
            tempValues.Description = tempValues.Description?.trim();
            props.submitHandler({ ...tempValues });
          }}
        >
          {({
            setErrors,
            values,
            errors,
            validateForm,
            handleSubmit,
            setFieldValue,
          }) => {
            return (
              <Form className="user-form" onSubmit={handleSubmit}>
                {/* <FormObserver /> */}
                {props.dataLoading || props.actionLoading ? (
                  <FormLoader
                    loading={props.dataLoading || props.actionLoading}
                  />
                ) : null}
                <div className="row">
                  {
                    props.schedulerId === -1 ?
                      <div className="col-12 d-flex align-items-center">
                        <div className="me-3">
                          <Field
                            type="radio"
                            name="IsUpdateNow"
                            value="0"
                            id="updateNow"
                            className="form-check-input"
                          />
                          <label className="form-check-label" htmlFor="updateNow">
                            <FormattedMessage id="update_now" />
                          </label>
                        </div>
                        <div className="me-3">
                          <Field
                            type="radio"
                            name="IsUpdateNow"
                            value="1"
                            id="updateDate"
                            className="form-check-input"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="updateDate"
                          >
                            <FormattedMessage id="schedule_date_upcoming" />
                          </label>
                        </div>

                        <div className={`${values.IsUpdateNow === "1" ? "d-block" : "d-none"}`}>
                          <Field
                            className="form-control"
                            name="ScheduleDate"
                            errClassName="position-absolute"
                            as={FormikDateTimeFieldMUI}
                            minutesStep={30}
                            minDate={props.initialValues.ScheduleDate}
                            disabled={values.IsUpdateNow === "1" ? true : false}
                            disableFuture={false}
                            max={moment(
                              props?.initialValues?.ScheduleDate
                            )
                              .add(6, "months")
                              .format(DATE_TIME_FORMAT_WITHOUT_SECONDS)}
                            min={moment(
                              props?.initialValues?.ScheduleDate
                            ).format(DATE_TIME_FORMAT_WITHOUT_SECONDS)}
                            ampm="false"
                          />
                          {/* <CustomTooltip id="schedule_date_info" message="schedule_date_info" /> */}
                        </div>

                      </div> :
                      <div className="col-12 d-flex align-items-center">

                        <Label
                          className="label-style"
                          required={true}
                          label="schedule_date_upcoming"
                        />
                        <div className="">
                          <Field
                            className="form-control"
                            name="ScheduleDate"
                            errClassName="position-absolute"
                            as={FormikDateTimeFieldMUI}
                            disabled={values.IsUpdateNow === "1" ? true : false}
                            disableFuture={false}
                            max={moment(
                              props?.initialValues?.ScheduleDate
                            )
                              .add(6, "months")
                              .format(DATE_TIME_FORMAT_WITHOUT_SECONDS)}
                            min={moment(
                              props?.initialValues?.ScheduleDate
                            ).format(DATE_TIME_FORMAT_WITHOUT_SECONDS)}
                            ampm="false"
                          />
                        </div>
                      </div>

                  }
                </div>
                <div className="row mt-3">
                  <div className="col-sm-6 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style text-dark"
                        required={true}
                        label="available_configs"
                      />
                      <Field
                        id="Configurations"
                        className="form-control"
                        name="ConfigId"
                        options={props.configOptions}
                        as={FormikFormSelect}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style text-dark"
                        required={true}
                        label="schedule_duration_limit"
                      />
                      <Field
                        id="ScheduleDurationDay"
                        className="form-control"
                        name="ScheduleDurationDay"
                        options={scheduleDurationDayOptions(7)}
                        as={FormikFormSelect}
                      />
                    </div>
                  </div>
                </div>
                {
                  props.schedulerId > 0 &&
                  <div className="form-group row mt-3 d-flex align-items-center">
                    <div className={`${props.schedulerId > 0 ? "col-md-4" : "col-md-6"}`}>
                      <Field
                        type="radio"
                        name="WantToUpdateDevices"
                        value="false"
                        id="useOldDeviceList"
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="useOldDeviceList"
                      >
                        <FormattedMessage id="use_old_device_list" />
                      </label>
                    </div>
                    <div className={`${props.schedulerId > 0 ? "col-md-8" : "col-md-6"}`}>
                      <Field
                        type="radio"
                        name="WantToUpdateDevices"
                        value="true"
                        id="WantToUpdateDevices"
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="WantToUpdateDevices"
                      >
                        <FormattedMessage id="provide_new_device_list" />
                      </label>
                    </div>
                  </div>
                }
                {((values.WantToUpdateDevices == "false" && props.schedulerId == -1) ||
                  (values.WantToUpdateDevices === "true" && props.schedulerId > 0)) && (
                    <>
                      <div className="form-group row mt-3">
                        <div className="col-12 ">
                          <Label
                            className="label-style "
                            required={true}
                            label="apply_on"
                          />
                          <div className="row g-1 fancy-radio">
                            <div className="col-6">
                              <Field
                                className="form-check-input"
                                name="IsAppliedOnGroup"
                                type="radio"
                                value="true"
                                id="group"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="group"
                              >
                                <img src={groupimg} alt="" />
                                <FormattedMessage id="group" />
                              </label>
                            </div>

                            <div className="col-6">
                              <Field
                                className="form-check-input"
                                name="IsAppliedOnGroup"
                                type="radio"
                                value="false"
                                id="device"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="device"
                              >
                                <img src={deviceimg} alt="" />
                                <FormattedMessage id="device" />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12 mt-3"
                          style={{
                            display:
                              values.IsAppliedOnGroup.toString() === "true"
                                ? "block"
                                : "none",
                          }}
                        >
                          <Label
                            className="label-style "
                            required={true}
                            label="choose_group"
                          />
                          <div className="">
                            <Field
                              name="GroupIds"
                              className="form-control react-select-parent"
                              isMulti={true}
                              isSearchable={true}
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              options={
                                values?.GroupIds?.length > 0
                                  ? values?.GroupIds?.findIndex(
                                    (item: any) => item.id === -1
                                  ) !== -1
                                    ? props.groupOptions[0]
                                    : props.groupOptions.filter(
                                      (item: any) => item.id !== -1
                                    )
                                  : props.groupOptions ?? []
                              }
                              as={FormikFormInputMultipleSelect}
                            />
                          </div>
                        </div>
                        <div
                          className="col-12 mt-3"
                          style={{
                            display:
                              values.IsAppliedOnGroup.toString() === "false"
                                ? "block"
                                : "none",
                          }}
                        >
                          <Label
                            className="label-style  me-1"
                            required={values.IsAppliedOnGroup === "false"}
                            label="upload_csv"
                          />
                          <a
                            href="javascript:;"
                            className="download_icon"
                            onClick={() =>
                              downloadDeviceICCIDDummyCSVHandler("SampleCSV")
                            }
                            title={formatMessage("download_sample_csv")}
                          >
                            <svg
                              version="1.1"
                              x="0px"
                              y="0px"
                              fill="currentColor"
                              height="13"
                              width="13"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <g>
                                  <path
                                    d="M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64
c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472
c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z"
                                  />
                                </g>
                              </g>
                              <g>
                                <g>
                                  <path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z" />
                                </g>
                              </g>
                            </svg>
                          </a>
                          <span className="text-muted small float-end">
                            <FormattedMessage id="no_of_iccids" /> : &nbsp;
                            {getNoOfRecordsFromFile(values)}
                          </span>
                          <div>
                            <Field
                              name="ICCIDsFile"
                              className="form-control "
                              handleFileUpload={handleICCIDFileUpload}
                              getFileName={getFileName}
                              as={FormikFormFileInput}
                            />

                          </div>
                        </div>

                      </div>
                    </>
                  )}
                <div className="form-group mt-3">
                  <Label
                    className="label-style "
                    label="fota_desc"
                  />
                  <Field
                    className="form-control"
                    name="Description"
                    type="text"
                    validcharacter={["."]}
                    placeholder="fota_desc"
                    as={FormikFormTextArea}
                  />
                </div>
                <div className="form-group mt-3 text-end">
                  <LoaderButton
                    type="submit"
                    isLoading={props.actionLoading}
                    disabled={values.IsUpdateNow === "1" ? true : false}
                    text={props.schedulerId > 0 ? "update" : "add"}
                  />
                  <Button
                    variant="secondary"
                    type="button"
                    onClick={(e) => props.onModalClosed()}
                    disabled={props.actionLoading}
                    className="ms-2"
                  >
                    <FormattedMessage id="button_cancel" />
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default ScheduleFirmwareUpdateForm;
